<template>
  <div>
    <v-btn v-if="acl.isAllowed('createUserFile')" @click="$router.push('user-files/new')">
      <v-icon>add</v-icon>
    </v-btn>
    <v-dialog  width="1000" v-model="dialog">
      <v-sheet>
        <div>
          <v-progress-linear indeterminate color="primary" v-if="loading || data ==null" spacing="pr-4"></v-progress-linear>
          <PdfViewer  v-if="data!=null" :base64="pdfData"></PdfViewer>
        </div>
        <v-btn style="z-index: 99999999" color="blue darken-1" flat @click="dialog=false">{{ $t('cyclic.abort') }}</v-btn>
        <v-btn v-if="data" style="z-index: 99999999" color="green darken-1" flat @click="download()">Pobierz</v-btn>
      </v-sheet>
    </v-dialog>

    <div style="margin: auto;max-width:1440px;margin-bottom: 1rem"><h3>Pliki do pobrania:</h3></div>
    <v-data-table style='max-width:1440px;margin:auto' :headers="headers" :items="files">
      <template v-slot:items="props">
        <td>{{ props.item.id }}</td>
        <td>{{ props.item.real_name }}</td>
        <td v-if="acl.isAllowed('createUserFile')">{{ getTeamNames(props.item) }}</td>
        <td>
          <v-btn icon>
            <v-icon @click="load(props.item)" color="blue">preview</v-icon>
          </v-btn>
          <v-btn icon>
            <v-icon @click="load(props.item, true)" color="green">download</v-icon>
          </v-btn>
          <v-btn v-if="acl.isAllowed('deleteUserFile')" icon>
            <v-icon @click="deleteFile(props.item.id)" color="red">delete</v-icon>
          </v-btn>
          <EditTeams :file-id="props.item.id" :team-ids="props.item.teams.map(e=>e.id)"
                     v-if="acl.isAllowed('createUserFile') && acl.isAllowed('teamView')"
                     @fileTeamUpdated="teamUpdated($event)">
          </EditTeams>
        </td>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import download from "../../mixins/download"
import Messenger from "../../plugins/Messenger"
import PdfViewer from "@/components/pdf/Viewer.vue"
import Cache from "../../helpers/Cache"
import Acl from "../../plugins/Acl"
import EditTeams from "./EditTeams.vue"

export default {
  components:{PdfViewer, EditTeams},
  mixins: [download],
  data() {
    return {
      files: [],
      cache: new Cache(),
      acl: new Acl(),
      data: null,
      dialog: false,
      loading: false,
    }
  },
  computed:{
    pdfData: function (){
      return `data:application/pdf;base64,${this.data}`
    },
    headers: function(){
      let headers = [
        {text: "Id", value: "id", width:"70px"},
        {text: "Name", value: "real_name"},
        {text: "Akcje"}
      ]

      if (this.acl.isAllowed('createUserFile')) {
        headers.splice(2, 0, {text: "Teams"});
      }
      return headers
    }
  },
  created() {
    this.$http.get('user-files').then(data => {
      this.files = data.data
    })
  },
  methods:{
    teamUpdated(item){
      let file = this.files.find(el => el.id == item.id)
      if(file){
        file.teams = item.teams
      }
    },
    getTeamNames(item){
      if(item.teams){
        return item.teams.map(el=>el.name).join(", ")
      }
    },
    deleteFile(id){
      this.$http.delete('user-file/' +id).then(()=>{
        this.files = this.files.filter(file => file.id != id)
        Messenger.emitSuccess("Usunięto plik")
      }).catch(()=>{
        Messenger.emitError("Problem z usunięciem")
      })
    },
    load(item, download = false) {
      let id = item.id
      this.name = item.real_name
      this.loading = true
      this.dialog = !download;
      this.data = null

      let file = this.cache.get(id)
      if (file) {
        this.data = file
        this.loading = false
        return download ? this.download() : true
      }

      this.$http.get(`user-file/${id}/base64`)
        .then(data => {
          this.data = data.data
          this.cache.add(id, data.data)
          this.loading = false
          return download ? this.download() : true
        })
        .catch(() => {
          this.dialog = false
          Messenger.emitError("Bład przy pobieraniu")
        })
    },
    download(){
      let url = `data:application/pdf;base64,` + this.data
      return this.downloadBase64(url,this.name)
    },
  },
}
</script>
<style scoped>

</style>